import { render, staticRenderFns } from "./PdfEditor.vue?vue&type=template&id=58500843&scoped=true&"
import script from "./PdfEditor.vue?vue&type=script&lang=ts&"
export * from "./PdfEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PdfEditor.vue?vue&type=style&index=0&id=58500843&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58500843",
  null
  
)

export default component.exports